<template>
  <div class="pl-2 pr-2">
    <div class="col eHabilitacao--border">
      <div class="row">
        <div class="col eHabilitacao--header eHabilitacao--header50 pt-1 pb-1">
          <div class="row no-gutters">
            <div class="col">
              <div class="cursor-pointer inline-flex mt-2 pt-1"
                   @click="$emit('onSetActualPage', 1)">
                <icon-svg icon="arrowLeft"
                          class="icons--white icon--xs eHabilitacao--marginMinusLeft" />
                <icon-svg icon="arrowLeft"
                          class="icons--white icon--xs" />
              </div>
            </div>
            <div class="col">
              <b-button class="eHabilitacao--btnTransparent"
                        :disabled="propActualPage == 1"
                        @click="$emit('onActualPageMinus')">
                <icon-svg icon="arrowLeft"
                          class="icons--white icon--xs" />
              </b-button>
            </div>
            <div class="col-4 pt-1">
              <v-select v-model="localActualData"
                        class="vSelect"
                        :options="propPagesSelect"
                        :clearable="false"
                        @input="$emit('onSetActualPage', localActualData)" />
            </div>
            <div class="col-2">
              <b-button class="eHabilitacao--btnTransparent"
                        :disabled="propActualPage == propPagesSelect.length"
                        @click="$emit('onActualPagePlus')">
                <icon-svg icon="arrowRight"
                          class="icons--white icon--xs" />
              </b-button>
            </div>
            <div class="col text-right">
              <div class="cursor-pointer inline-flex mt-2 pt-1"
                   @click="$emit('onSetLastPage')">
                <icon-svg icon="arrowRight"
                          class="icons--white icon--xs" />
                <icon-svg icon="arrowRight"
                          class="icons--white icon--xs eHabilitacao--marginMinusRight" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <collapse-default id="collapse_comum"
                          :style-default="false"
                          :collapse-visible="propDocumentos.length != 0"
                          icon-position="left">
          <template v-slot:header>
            <strong> Documentos</strong>{{ propDocumentos.length == 0 && ' - Sem documento' || null }}
          </template>

          <template v-slot:content>
            <div>
              <div v-for="(document, index) of propDocumentos"
                   :key="`document_${ index }`"
                   class="eHabilitacao--cursor row pt-1 pb-1">
                <div v-b-tooltip.hover.top="'Ir para página: ' + (document.indicePage)"
                     class="col-9"
                     @click="$emit('onSetActualPage', (document.indicePage))">
                  {{ getName(document.tag) }}
                </div>
                <div v-if="document.habilitacao_casamento_documento_id && document.tag != 'Memorial'"
                     class="col">
                  <div class="row no-gutters">
                    <div class="col">
                      <div v-if="index != 0 && document.tag != 'Memorial' && (!propHabilitacao.gerar_autuacao && index > 2 || propHabilitacao.gerar_autuacao && index > 1)"
                           v-b-tooltip.hover.top="'Mover pra cima'"
                           @click="$emit('onSetOrdem', 'up', document)">
                        <icon-svg icon="arrowBoldUp"
                                  class="icon--sm icons--white" />
                      </div>
                    </div>
                    <div class="col">
                      <div v-if="index != (propDocumentos.length - 1) && !(propHabilitacao.gerar_autuacao && index == 0)"
                           v-b-tooltip.hover.top="'Mover pra baixo'"
                           @click="$emit('onSetOrdem', 'down', document)">
                        <icon-svg icon="arrowBoldDown"
                                  class="icon--sm icons--white" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </collapse-default>

        <collapse-default id="collapse_certidoes"
                          :style-default="false"
                          :collapse-visible="propCertidoes.length > 0"
                          icon-position="left">
          <template v-slot:header>
            <strong> Certidões</strong>{{ propCertidoes.length == 0 && ' - Sem documento' || null }}
          </template>

          <template v-slot:content>
            <div v-for="(document, index) of propCertidoes"
                 :key="`document_${ index }`"
                 class="eHabilitacao--cursor row pt-1 pb-1">
              <div v-b-tooltip.hover.top="'Ir para página: ' + (document.indicePage)"
                   class="col-9"
                   @click="$emit('onSetActualPage', (document.indicePage))">
                {{ getName(document.tag) }}
              </div>
              <div v-if="document.habilitacao_casamento_documento_id"
                   class="col">
                <div class="row no-gutters">
                  <div class="col">
                    <div v-if="index != 0"
                         v-b-tooltip.hover.top="'Mover pra cima'"
                         @click="$emit('onSetOrdem', 'up', document)">
                      <icon-svg icon="arrowBoldUp"
                                class="icon--sm icons--white" />
                    </div>
                  </div>
                  <div class="col">
                    <div v-if="index != (propCertidoes.filter(doc => !!doc.habilitacao_casamento_documento_id).length - 1)"
                         v-b-tooltip.hover.top="'Mover pra baixo'"
                         @click="$emit('onSetOrdem', 'down', document)">
                      <icon-svg icon="arrowBoldDown"
                                class="icon--sm icons--white" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </collapse-default>
      </div>
    </div>
  </div>
</template>

<script>
  /* components */
  import CollapseDefault from "@/components/SofiaRei/Resumo/Collapses/CollapseDefault"

  export default {
    name: "Listagem",
    components: {
      CollapseDefault
    },
    props: {
      propPagesSelect: {
        type: Array,
        default: () => ([])
      },
      propActualPage: {
        type: Number,
        default: () => 1
      },
      propDocumentos: {
        type: Array,
        default: () => ([])
      },
      propCertidoes: {
        type: Array,
        default: () => ([])
      },
      propHabilitacao: {
        type: Object,
        default: () => ({})
      },
      propQtdPages: {
        type: Number,
        default: () => 0
      }
    },
    data () {
      return {
        localActualData: 1
      }
    },
    watch: {
      propActualPage () {
        this.localActualData = this.propActualPage
      }
    },
    methods: {
      calculatePage (qtd) {
        // caso já exista um casamento a partir desta habilitação
        // sera adicionado +1 na contagem de menos paginas
        const cumprimento = !this.propHabilitacao.casamento ? 0 : 1

        // retornando qtd calculada
        return this.propQtdPages - (qtd + cumprimento)
      },

      getName (tag) {
        const valores = {
          processo_autuacao_sofia: 'Processo autuação',
          processo_autuacao_assinado_sofia: 'Processo autuação',
          capa_sofia: 'Capa',
          memorial_sofia: 'Memorial',
          certidoes_sofia: 'Certidões',
          edital_proclamas_sofia: 'Edital Proclamas',
          outras_certidoes_sofia: 'Outras Certidões',
          cumprimento_sofia: 'Cumprimento',
          certidao_habilitacao_sofia: 'Certidão Habilitação'
        }

        return valores[tag] || tag
      }
    }
  }
</script>

<style scoped>

</style>
